// Nutrient Calculator Utility for React
// Updated: 04-23-2026 based on "Nutrient Calculator 04_21_2026.xlsx"
// BUG FIX: Corrected Veg 3 Target PPM from 330 to 300 (Matches Excel formula =D19*500).
// BUG FIX: Removed ENZYME and Beneficial from Add-Back calculations.

/* OLD LOGIC (BACKUP)
const configOld = {
    nutrients: {
        COCO_CAL: [2.4, 2.4, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2, 1],
        VEG_A: [2.4, 2.4, 2.5, 0, 0, 0, 0, 0, 0, 0, 0],
        VEG_B: [2.4, 2.4, 2.5, 0, 0, 0, 0, 0, 0, 0, 0],
        BLOOM_A: [0, 0, 0, 3.5, 4.5, 6, 6, 7, 6, 4, 3],
        BLOOM_B: [0, 0, 0, 3.5, 4.5, 6, 6, 7, 6, 4, 3],
        BOOSTER_MID: [0, 0, 0, 0.5, 1.5, 2, 3, 3.5, 3, 2, 1.5],
        BOOSTER_MOAB: [0, 0, 0, 0.5, 0, 0, 0, 0, 1, 1.5, 0.5]
    },
    ec_values: [0.600, 0.600, 0.600, 0.9, 1.0, 1.2, 1.3, 1.5, 1.4, 1.0, 0.8],
    ppm_500_multipliers: [500, 500, 550, 472.2, 500, 500, 500, 500, 500, 550, 500],
    addback_formulas: {
        COCO_CAL: [true, true, true, true, true, true, true, true, true, true, true],
        VEG_A: [true, true, true, false, false, false, false, false, false, false, false],
        VEG_B: [true, true, true, false, false, false, false, false, false, false, false],
        BLOOM_A: [false, false, false, true, true, true, true, true, true, true, true],
        BLOOM_B: [false, false, false, true, true, true, true, true, true, true, true],
        BOOSTER_MID: [false, false, false, true, true, true, true, true, true, true, true],
        BOOSTER_MOAB: [false, false, false, false, false, false, false, false, true, true, true]
    }
};
*/

const config = {
    // Rates in mL per gallon or Grams per gallon (for MOAB)
    // Corrected Rates from D:\Work\Frosted_Farms\Frosted_Farms_Work_Task\Nutrient Calculator 04_21_2026.xlsx
    // Indices: 0:Veg1, 1:Veg2, 2:Veg3, 3:B1, 4:B2, 5:B3, 6:B4, 7:B5, 8:B6, 9:B7, 10:B8, 11:Flush
    nutrients: {
        "BALANCE":             [0,   0,    0,        0.5, 0.5, 0.75, 1,   1,   2,   1.5, 0,   0  ],
        "COCO CAL":            [1.2, 1.85, 2.291667, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.0, 1.0, 1.0],
        "VEG A":               [1.2, 1.85, 2.291667, 0,   0,   0,   0,   0,   0,   0,   0,   0  ],
        "VEG B":               [1.2, 1.85, 2.291667, 0,   0,   0,   0,   0,   0,   0,   0,   0  ],
        "BLOOM A":             [0,   0,    0,        3.5, 4.5, 6.0, 6.0, 7.0, 6.0, 4.0, 3.0, 0  ],
        "BLOOM B":             [0,   0,    0,        3.5, 4.5, 6.0, 6.0, 7.0, 6.0, 4.0, 3.0, 0  ],
        "BOOSTER - Mid":       [0,   0,    0,        0.5, 1.5, 2.0, 3.0, 3.5, 3.0, 2.0, 1.5, 0  ],
        "BOOSTER - Late Grams":[0,   0,    0,        0.5, 0,   0,   0,   0,   1.0, 1.5, 0.5, 0  ],
        "ENZYME":              [2.5, 2.5,  2.5,      2.5, 2.5, 2.5, 2.5, 0,   0,   0,   0,   0  ],
        "Beneficial":          [0.5, 0.5,  0.5,      0,   0,   0,   0,   0,   0,   0,   0,   0  ]
    },
    // Corrected Target PPM values (Veg 3 corrected from 330 to 300)
    target_ppm_500: [175, 200, 300, 424.98, 500, 600, 650, 750, 700, 550, 400, 30],
    
    // Addback formulas activation flags
    // Determines if a nutrient should be calculated for "Add Back" (Rows 30-36 in Excel)
    addback_formulas: {
        "BALANCE":             [false, false, false, false, false, false, false, false, false, false, false, false], // User disabled
        "COCO CAL":            [true,  true,  true,  true,  true,  true,  true,  true,  true,  true,  true,  true ],
        "VEG A":               [true,  true,  true,  false, false, false, false, false, false, false, false, false],
        "VEG B":               [true,  true,  true,  false, false, false, false, false, false, false, false, false],
        "BLOOM A":             [false, false, false, true,  true,  true,  true,  true,  true,  true,  true,  false],
        "BLOOM B":             [false, false, false, true,  true,  true,  true,  true,  true,  true,  true,  false],
        "BOOSTER - Mid":       [false, false, false, true,  true,  true,  true,  true,  true,  true,  true,  false],
        "BOOSTER - Late Grams":[false, false, false, false, false, false, false, false, true,  true,  true,  false], // User disabled bloom start
        "ENZYME":              [false, false, false, false, false, false, false, false, false, false, false, false], 
        "Beneficial":          [false, false, false, false, false, false, false, false, false, false, false, false]  
    }
};

const columnMap = {
    "VEG 1": 0, "VEG 2": 1, "VEG 3": 2,
    "BLOOM 1": 3, "BLOOM 2": 4, "BLOOM 3": 5, "BLOOM 4": 6,
    "BLOOM 5": 7, "BLOOM 6": 8, "BLOOM 7": 9, "BLOOM 8": 10,
    "Flush": 11
};

/**
 * Calculates the amount of each nutrient to add back based on system volume and current PPM.
 * Formula: ((targetPPM - currentPPM) / targetPPM) * (systemVolume * ratePerGallon)
 * 
 * @param {number} systemVolume - Total system volume in gallons
 * @param {number} currentPPM - Current measured PPM (500 scale)
 * @param {string} columnName - Growth phase name (e.g., "VEG 1", "BLOOM 3")
 * @returns {object} - Calculated ml/grams for each nutrient
 */
export function calculateNutrientColumn(systemVolume, currentPPM, columnName) {
    const columnIndex = columnMap[columnName];
    if (columnIndex === undefined) return {};
    
    const targetPPM = config.target_ppm_500[columnIndex];
    const result = {};

    Object.keys(config.nutrients).forEach((nutrientKey) => {
        const isApplicable = config.addback_formulas[nutrientKey][columnIndex];
        const rate = config.nutrients[nutrientKey][columnIndex];
        
        if (isApplicable && rate > 0) {
            const baseAmount = systemVolume * rate;
            // Formula from Excel: ((Target - Current) / Target) * FullSwapAmount
            const calculated = Math.round(((targetPPM - currentPPM) / targetPPM) * baseAmount);
            result[nutrientKey] = calculated > 0 ? calculated : 0;
        } else {
            result[nutrientKey] = "";
        }
    });

    return result;
}

export const nutrientColumnNames = Object.keys(columnMap);